import React from 'react'


class FormsTester extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className="LinksTester">
        <h1>Forms Test:</h1>
        <div className="pt-form-group">
          <label className="pt-label" htmlFor="example-form-group-input-a">
            Text input:
          </label>
          <div className="pt-form-content">
            <input id="example-form-group-input-a" className="pt-input" placeholder="Placeholder text" type="text" dir="auto" />
          </div>
        </div>
        <div className="pt-form-group pt-disabled">
          <label className="pt-label" htmlFor="example-form-group-input-b">
            Disabled text input:
          </label>
          <div className="pt-form-content">
            <div className="pt-input-group">
              <input id="example-form-group-input-b" disabled className="pt-input" type="email" dir="auto" />
            </div>
          </div>
        </div>
        <div className="pt-form-group">
          <label className="pt-label" htmlFor="example-form-group-input-b">
            Number input:
          </label>
          <div className="pt-form-content">
            <div className="pt-input-group">
              <input id="example-form-group-input-b" className="pt-input" type="number" dir="auto" />
            </div>
          </div>
        </div>
        <div className="pt-form-group">
          <label className="pt-label" htmlFor="example-form-group-input-b">
            Email input:
          </label>
          <div className="pt-form-content">
            <div className="pt-input-group">
              <input id="example-form-group-input-b" className="pt-input" type="email" dir="auto" />
            </div>
          </div>
        </div>
        <div className="pt-form-group">
          <div className="pt-form-content">
            <label className="">
              <input id="example-form-group-switch-c" type="checkbox" className="sr4"/>
              Regular checkbox
            </label>
          </div>
        </div>
        <div className="pt-form-group">
          <div className="pt-form-content">
            <label className="pt-control pt-switch">
              <input id="example-form-group-switch-c" type="checkbox" />
              <span className="pt-control-indicator"></span>
              Custom checkbox
            </label>
          </div>
        </div>
        <div className="pt-form-group">
          <div className="pt-form-content">
            <div className="s1">
              <label>
                <input type="radio" name="docs-radio-native" className="sr3"/>
                Native Radio button A
              </label>
            </div>
            <div className="s1">
              <label>
                <input type="radio" name="docs-radio-native" className="sr3"/>
                Native Radio button B
              </label>
            </div>
          </div>
        </div>
        <div className="pt-form-group">
          <div className="pt-form-content">
            <label className="pt-control pt-radio">
              <input type="radio" name="docs-radio-regular"/>
              <span className="pt-control-indicator"></span>
              Custom Radio button A
            </label>
            <label className="pt-control pt-radio">
              <input type="radio" name="docs-radio-regular"/>
              <span className="pt-control-indicator"></span>
              Custom Radio button B
            </label>
          </div>
        </div>
        <div className="pt-form-group">
          <div className="pt-select">
            <select>
              <option selected>Choose an item...</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
              <option value="4">Four</option>
            </select>
          </div>
        </div>
        <div className="pt-form-group">
          <div className="pt-form-group">
            <label className="pt-label" htmlFor="example-form-group-input-a">
              Text input:
            </label>
            <div className="pt-form-content">
              <textarea className="pt-input" dir="auto">Test text area</textarea>
            </div>
          </div>
        </div>
        <div className="pt-form-group">
          <div className="pt-form-group">
            <label className="pt-label" htmlFor="example-form-group-input-a">
              Editablecontent div:
            </label>
            <div className="pt-form-content">
              <div className="editable-div" contentEditable={true} dangerouslySetInnerHTML={{__html: "Editablecontent test"}}></div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default FormsTester;



// WEBPACK FOOTER //
// ./src/components/testplayground/FormsTester.js